module.exports = __webpack_public_path__ + "img/guide-icon2.b6418d43.png";